import { FormProvider } from 'react-hook-form'

import { ScrollContainer } from '@/components/ScrollContainer'
import { GeoFenceCancelDialog } from '@/feature/observatory'

import { GeofenceAlertsField } from '../GeofenceAlertsField'
import { AsideFooter } from './components/AsideFooter'
import { FormErrorField } from './components/FormErrorField'
import { HighRiskField } from './components/HighRiskField'
import { NewGeoFenceShapeField } from './components/NewGeoFenceShapeField'
import { TitleField } from './components/TitleField'
import styles from './GeoFenceCreateEdit.module.css'
import { GeoFenceCreateEditProps } from './GeoFenceCreateEdit.types'
import { useGeoFenceCreateEdit } from './useGeoFenceCreateEdit'

export const GeoFenceCreateEdit = ({ setSubScreen, geoFence }: GeoFenceCreateEditProps) => {
  const {
    formMethods,
    onSubmit,
    dialogOpen,
    setDialogOpen,
    closeAction,
    closeScreen,
    simulatedPosition,
    setSimulatedPosition,
  } = useGeoFenceCreateEdit({ setSubScreen, geoFence })

  return (
    <>
      <GeoFenceCancelDialog
        open={dialogOpen}
        onCancel={() => setDialogOpen(false)}
        onDiscard={closeScreen}
      />
      <div className={styles.create} data-testid="geofence-create-edit">
        <FormProvider {...formMethods}>
          <form
            className={styles.createForm}
            onSubmit={formMethods.handleSubmit(onSubmit)}
            data-testid="geofence-form"
          >
            <ScrollContainer contentClassName={styles.scrollContainer}>
              <div className={styles.createInfo}>
                <div className={styles.section}>
                  <div>
                    <FormErrorField />
                    <TitleField />
                  </div>
                  <NewGeoFenceShapeField
                    simulatedPosition={simulatedPosition}
                    setSimulatedPosition={setSimulatedPosition}
                    geoFence={geoFence}
                  />

                  <HighRiskField />
                </div>

                <hr className={styles.geoFenceDivider} />

                <GeofenceAlertsField geofenceAlertRules={geoFence?.alertRules} />
              </div>
            </ScrollContainer>
            <AsideFooter closeAction={closeAction} />
          </form>
        </FormProvider>
      </div>
    </>
  )
}
